import type { TaskNode } from "./types";
import { locateOrNull, findParent } from "./tree";
import { fmt } from "./format";

// a single top-level node is treated as a wrapper: it's dropped from displayed paths
export function rootIsSolo(tree: TaskNode[]): boolean {
  return tree.length === 1;
}

// drop the lone root from a root→node name list, e.g. "A > B > C" → "B > C"
export function trimPath(tree: TaskNode[], names: string[]): string[] {
  return rootIsSolo(tree) && names.length > 1 ? names.slice(1) : names;
}

// build "Root > Child > Leaf" from the current model (fresh after renames)
export function currentPath(tree: TaskNode[], id: string): string {
  const names: string[] = [];
  let cur: string | null = id;
  while (cur) {
    const loc = locateOrNull(tree, cur);
    if (!loc) break;
    names.unshift(loc.node.name);
    const p = findParent(tree, cur);
    cur = p ? p.parentNode.id : null;
  }
  return trimPath(tree, names).join(" > ");
}

// flatten leaf tasks to "A > B > C - 2d" lines (lone-root trimmed)
export function leafLines(tree: TaskNode[]): string[] {
  const solo = rootIsSolo(tree);
  const out: string[] = [];
  (function walk(nodes: TaskNode[], ancestors: string[]) {
    nodes.forEach((node) => {
      const path = ancestors.concat(node.name);
      if (node.children.length === 0) {
        const shown = solo && path.length > 1 ? path.slice(1) : path;
        let line = shown.join(" > ");
        if (node.estimate > 0) line += " - " + fmt(node.estimate) + "d";
        out.push(line);
      } else {
        walk(node.children, path);
      }
    });
  })(tree, []);
  return out;
}
